import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface BreadcrumbItem {
  label: string;
  url: string;
  section?: string;
}

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  private breadcrumbsSubject = new BehaviorSubject<BreadcrumbItem[]>([]);
  public breadcrumbs$ = this.breadcrumbsSubject.asObservable();

  private dynamicBreadcrumbs = new Map<string, string>();
  private dynamicUpdateSubject = new BehaviorSubject<void>(undefined);
  public dynamicUpdate$ = this.dynamicUpdateSubject.asObservable();

  setBreadcrumbs(breadcrumbs: BreadcrumbItem[]): void {
    this.breadcrumbsSubject.next(breadcrumbs);
  }

  updateDynamicBreadcrumb(key: string, value: string): void {
    this.dynamicBreadcrumbs.set(key, value);
    this.emitBreadcrumbUpdate();
  }

  getDynamicBreadcrumb(key: string): string | undefined {
    return this.dynamicBreadcrumbs.get(key);
  }

  private emitBreadcrumbUpdate(): void {
    // Emit a signal to trigger breadcrumb rebuild
    this.dynamicUpdateSubject.next(undefined);
  }

  clearDynamicBreadcrumbs(): void {
    this.dynamicBreadcrumbs.clear();
  }
}
